/* eslint import/prefer-default-export: 0 */

export const ACTIVE_DIMENSIONS_UPDATE = 'ACTIVE_DIMENSIONS_UPDATE';
